






























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SystemMobanToufatuxiangCmp extends Vue {
  private defaultValue: any[] = [];
  private defaultValue2: any = "";
}
